import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { DashboardShell, DashboardShellProvider } from "../app/molecules/DashboardLayout";

const AuthenticatedLayout = () => (
  <DashboardShellProvider>
    <DashboardShell>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </DashboardShell>
  </DashboardShellProvider>
);

export default AuthenticatedLayout;
